import React from "react";

const TimesheetTableHeader = ({ color = "primary" }) => {
  return (
    <div className="px-5">
      <div className=" grid grid-cols-[1.5fr_repeat(8,1fr)] gap-1 text-sm text-center uppercase tracking-wide">
        <div></div>
        <div className={`p-1 text-white bg-${color}`}>Mon</div>
        <div className={`p-1 text-white bg-${color}`}>Tue</div>
        <div className={`p-1 text-white bg-${color}`}>Wed</div>
        <div className={`p-1 text-white bg-${color}`}>Thu</div>
        <div className={`p-1 text-white bg-${color}`}>Fri</div>
        <div className={`p-1 text-white bg-${color}`}>Sat</div>
        <div className={`p-1 text-white bg-${color}`}>Sun</div>
        <div className={`p-1 text-white bg-${color}`}>Total</div>
      </div>
    </div>
  );
};

export default TimesheetTableHeader;
